import React from 'react'

import { Box } from '@mui/material'
import ParticelleForm from './ParticelleForm'
import { useSelector } from 'react-redux'



export const TerreniParticelleSlider = ({ cantine, setCantine }) => {
    const singleData = useSelector((state) => state?.particelle?.singleParticelle)
    console.log(singleData, "datasingle")

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra una particella</h2>
            </Box>
            <ParticelleForm cantine={cantine} setCantine={setCantine} singleData={singleData} table={true}  />
        </Box>
    )
}
